import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { Language } from '@context'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface UseLanguageStoreState {
  language: Language
  switchLanguage: (language: Language) => void
}

export const useLanguageStore = create<UseLanguageStoreState>()(
  persist(
    (set) => ({
      // The device's language until the person picks one (French when the
      // device is in a language the app does not have).
      language: 'auto',
      switchLanguage: (language) => set(() => ({ language })),
    }),
    { name: 'useLanguageStore', storage: createJSONStorage(() => AsyncStorage) },
  ),
)
